import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import { Tabs, Form, Select, Input } from 'antd';
import UserByroleSelect from './UserByroleSelect';
import { NeedAssignNode, ProcessNode } from '@/types/process';

interface AssigneeNode {
  [key: string]: {
    asignee: string[];
  };
}
interface ApproverSettingFormProps {
  approverSchema: ProcessNode;
  assigneeNode: AssigneeNode;
}

export const ApproverSettingForm: ForwardRefExoticComponent<PropsWithoutRef<ApproverSettingFormProps> & RefAttributes<Record<any, any>>> = forwardRef((
  props,
  ref,
) => {
  const { approverSchema, assigneeNode } = props;
  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    form,
  }));

  return (
    <Form form={form} layout="vertical" initialValues={assigneeNode} >
      <Tabs
        defaultActiveKey="1"
        tabPosition="left"
        style={{ height: 220 }}
      >
        {[...(approverSchema?.needAssignNodes || [])]?.reverse()?.map((item: NeedAssignNode) => {
          return (
            <Tabs.TabPane tab={item.nodeName || item.assigned_node} key={item.assigned_node} forceRender>
              {item.set_assignee ? (
                <Form.Item
                  name={[item.assigned_node, 'assignee']}
                  label="选择审批人"
                  rules={[
                    {
                      required: true,
                      message: '此项为必填项',
                    },
                  ]}
                >
                  <UserByroleSelect roleNumbers={item.assigneeFilterRole} userAccount={item.userAccount} mode="multiple" />
                </Form.Item>
              ) : null}
              {item.set_cc ? (
                <Form.Item
                  name={[item.assigned_node, 'cc']}
                  label="选择抄送人"
                  rules={[
                    {
                      required: true,
                      message: '此项为必填项',
                    },
                  ]}
                >
                  <UserByroleSelect roleNumbers={item.ccFilterRole} mode="multiple" />
                </Form.Item>
              ) : null}
            </Tabs.TabPane>
          );
        })}
      </Tabs>
    </Form>
  );
});
